import React  from 'react';
import { Helmet } from "react-helmet";

export default function PaymentFailed() {
    return (<>
        <Helmet>
            <title>Ошибка оплаты - ДавайНаСвидание</title>
        </Helmet>
        <div className="bg-background1 pt-14 pb-20">
            <section>
                <div className="container mx-auto">
                    <div>
                        <h2 className="text-xl lg:text-2xl font-bold text-blue uppercase">Оплата не произведена</h2>
                        <h3 className="text-xl mt-4 text-red uppercase font-bold">Возникла какая-то ошибка</h3>
                        <p className="mt-4 font-bold text-xl lg:text-base">
                            Если Вы уверены что оплата прошла, пожалуйста, обратитесь по телефону: 8 (926) 636-20-46.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    </>);
}